(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.viewer.skins.GridLeftHeaderSkin'] = {
  "react": [
    [
      "div",
      null,
      [
        "_grid"
      ],
      {
        "ref": "grid"
      }
    ]
  ],
  "params": {
    "shd": "BOX_SHADOW",
    "rd": "BORDER_RADIUS",
    "containerBrw": "BORDER_SIZE",
    "containerBrd": "BORDER_COLOR_ALPHA",
    "containerBg": "BG_COLOR_ALPHA",
    "headerDivider_w": "BORDER_SIZE",
    "headerBg": "BG_COLOR_ALPHA",
    "headerText": "TEXT_COLOR",
    "headerFont": "FONT",
    "columnDivider_w": "BORDER_SIZE",
    "columnDivider": "BORDER_COLOR_ALPHA",
    "headerDivider": "BORDER_COLOR_ALPHA",
    "row2Bg": "BG_COLOR_ALPHA",
    "rowBg": "BG_COLOR_ALPHA",
    "rowText": "TEXT_COLOR",
    "rowFont": "FONT",
    "rowDivider_w": "BORDER_SIZE",
    "rowDivider": "BORDER_COLOR_ALPHA",
    "selection": "BG_COLOR_ALPHA",
    "linkColor": "TEXT_COLOR",
    "linkHoverColor": "TEXT_COLOR",
    "paginationColor": "BG_COLOR_ALPHA",
    "cellPadding": "PADDING_RIGHT_SIZE",
    "rowOrCellHoverBg": "BG_COLOR_ALPHA",
    "headerColumnBg": "BG_COLOR_ALPHA",
    "headerColumnFont": "FONT",
    "headerColumnText": "TEXT_COLOR"
  },
  "paramsDefaults": {
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "rd": "0",
    "containerBrw": "1",
    "containerBrd": "color_5",
    "containerBg": "color_1",
    "headerDivider_w": "1",
    "headerBg": "color_17",
    "headerText": "color_5",
    "headerFont": "font_9",
    "columnDivider_w": "1",
    "columnDivider": "color_5",
    "headerDivider": "color_5",
    "row2Bg": "color_10",
    "rowBg": "color_1",
    "rowText": "color_5",
    "rowFont": "font_9",
    "rowDivider_w": "1",
    "rowDivider": "color_5",
    "selection": "color_13",
    "linkColor": "color_6",
    "linkHoverColor": "color_7",
    "paginationColor": "#000000",
    "cellPadding": "0",
    "rowOrCellHoverBg": "color_4",
    "headerColumnBg": "color_1",
    "headerColumnFont": "font_9",
    "headerColumnText": "color_5"
  },
  "css": {
    "%_grid": "height:100%;",
    "% #centerRow,% #borderLayout_eRootPanel > #center": "[shd]  [rd]  -webkit-filter:blur(0);",
    "% .ag-root": "border:[containerBrw] solid [containerBrd];[rd]  overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);",
    "% .ag-body-viewport-wrapper": "-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);",
    "% #borderLayout_eRootPanel": "overflow:visible !important;",
    "% .ag-body-viewport": "background:[containerBg];[rd]  border-top-left-radius:0;border-top-right-radius:0;",
    "% .ag-header": "background:[containerBg];padding-bottom:[headerDivider_w];box-sizing:content-box;position:relative;border:none;",
    "% .ag-header .ag-header-viewport": "overflow:visible;",
    "% .ag-header-cell": "background:[headerBg];color:[headerText];[headerFont]  border-right:[columnDivider_w] solid [columnDivider];",
    "% .ag-header-cell:last-child": "border-right:none;",
    "% .ag-header-cell::after": "content:'';position:absolute;width:inherit;left:0;bottom:calc(-1 * [headerDivider_w]);border-bottom:[headerDivider_w] solid [headerDivider];",
    "% .ag-scrolls .ag-body": "background:transparent;top:inherit !important;",
    "% .ag-scrolls .ag-body .ag-row-odd": "background:[row2Bg];",
    "% .ag-scrolls .ag-body .ag-row-even": "background:[rowBg];",
    "% .ag-scrolls .ag-body .ag-row": "color:[rowText];[rowFont]    box-sizing:border-box;border-bottom:[rowDivider_w] solid [rowDivider];",
    "% .ag-scrolls .ag-body .ag-row.ag-row-selected": "background:[selection];",
    "% .ag-scrolls .ag-body img": "max-height:100%;max-width:100%;",
    "% .ag-scrolls .ag-body .ag-body-container": "display:block;",
    "% .ag-overlay-loading-wrapper": "background:rgba(255, 255, 255, 0.3);",
    "% .ag-overlay-loading-center": "background:[containerBg];color:[rowText];[rowFont]  border:none;",
    "% .ag-body .ag-cell": "display:block;height:100%;width:100%;padding:0;",
    "% .ag-body .ag-cell.ag-cell-focus": "background:[selection];border-right:[columnDivider_w] solid [columnDivider];border-left:0;border-top:0;border-bottom:0;",
    "% .ag-body .ag-cell-link": "display:block;height:100%;",
    "% .ag-body .ag-cell-link-inline": "display:inline-block;",
    "% .ag-body .ag-cell-link,% .ag-body .ag-cell-link-inline": "color:[linkColor];",
    "% .ag-body .ag-cell-link:hover,% .ag-body .ag-cell-link-inline:hover": "color:[linkHoverColor];",
    "% .ag-header-cell-label": "position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);white-space:normal;",
    "% .cell-content-wrapper": "position:relative;height:100%;padding:2px;",
    "% .cell-content-wrapper .cell-text-wrapper": "display:table;width:100%;height:100%;",
    "% .cell-content-wrapper .cell-text-wrapper .ag-cell-text": "display:table-cell;vertical-align:middle;white-space:normal;",
    "% .cell-center-vertically": "position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);white-space:normal;",
    "% .ag-cell-no-focus": "border-right:[columnDivider_w] solid [columnDivider];border-left:0;border-top:0;border-bottom:0;",
    "% .ag-cell-no-focus:last-child": "border-right:none;",
    "% .ag-cell-image": "display:block;position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);",
    "% .ag-paging-page-summary-panel": "display:block;text-align:right;color:[paginationColor];[rowFont]",
    "% #pageRowSummaryPanel,% #btFirst,% #btLast": "display:none;",
    "% #btPrevious,% #btNext": "position:relative;width:20px;height:26px;line-height:27px;border:none;background:url('data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20fill%3D%22[paginationColor]%22%20points%3D%2212.8%2C20%2012%2C19.4%2017.7%2C13%2012%2C6.6%2012.8%2C6%2019%2C13%22%2F%3E%3C%2Fsvg%3E');background-size:20px 26px;background-repeat:no-repeat;background-position:center;color:transparent;padding:0;margin:0;",
    "% #btPrevious:not(:disabled),% #btNext:not(:disabled)": "cursor:pointer;",
    "% .ag-paging-panel": "padding:12px 0 0;",
    "% #btPrevious": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "% .ag-paging-button:hover": "opacity:.7;",
    "% .ag-paging-button:disabled": "opacity:.3;",
    "%.hide-pagination-panel .ag-paging-panel": "display:none;",
    "%.align-text-left .ag-header-cell": "text-align:left;padding-left:[cellPadding];",
    "%.align-text-left .ag-row": "text-align:left;",
    "%.align-text-left .ag-row .cell-content-wrapper": "padding-left:[cellPadding];",
    "%.align-text-left .ag-cell-image": "margin-right:auto;",
    "%.align-text-right .ag-header-cell": "text-align:right;padding-right:[cellPadding];",
    "%.align-text-right .ag-row": "text-align:right;",
    "%.align-text-right .ag-row .cell-content-wrapper": "padding-right:[cellPadding];",
    "%.align-text-right .ag-cell-image": "margin-left:auto;",
    "%.align-text-center .ag-header-cell": "text-align:center;padding:0;",
    "%.align-text-center .ag-row": "text-align:center;",
    "%.align-text-center .ag-row .ag-cell": "padding:0;",
    "%.align-text-center .ag-cell-image": "margin:auto;",
    "% .ag-cell-richtext": "height:inherit;",
    "%.disable-horizontal-scroll .ag-body-viewport": "overflow-x:hidden;",
    "% .ag-paging-row-summary-panel": "position:absolute;width:auto;padding-right:2px;",
    "%.select-rows .ag-row:hover": "background:[rowOrCellHoverBg];",
    "%.select-cells .ag-cell:hover": "background:[rowOrCellHoverBg];",
    "%.hide-header .ag-header": "display:none;",
    "% .first-column": "background:[headerColumnBg];[headerColumnFont]  color:[headerColumnText];"
  }
}
 skins['wysiwyg.viewer.skins.GridRightHeaderSkin'] = {
  "react": [
    [
      "div",
      null,
      [
        "_grid"
      ],
      {
        "ref": "grid"
      }
    ]
  ],
  "params": {
    "shd": "BOX_SHADOW",
    "rd": "BORDER_RADIUS",
    "containerBrw": "BORDER_SIZE",
    "containerBrd": "BORDER_COLOR_ALPHA",
    "containerBg": "BG_COLOR_ALPHA",
    "headerDivider_w": "BORDER_SIZE",
    "headerBg": "BG_COLOR_ALPHA",
    "headerText": "TEXT_COLOR",
    "headerFont": "FONT",
    "columnDivider_w": "BORDER_SIZE",
    "columnDivider": "BORDER_COLOR_ALPHA",
    "headerDivider": "BORDER_COLOR_ALPHA",
    "row2Bg": "BG_COLOR_ALPHA",
    "rowBg": "BG_COLOR_ALPHA",
    "rowText": "TEXT_COLOR",
    "rowFont": "FONT",
    "rowDivider_w": "BORDER_SIZE",
    "rowDivider": "BORDER_COLOR_ALPHA",
    "selection": "BG_COLOR_ALPHA",
    "linkColor": "TEXT_COLOR",
    "linkHoverColor": "TEXT_COLOR",
    "paginationColor": "BG_COLOR_ALPHA",
    "cellPadding": "PADDING_RIGHT_SIZE",
    "rowOrCellHoverBg": "BG_COLOR_ALPHA",
    "headerColumnBg": "BG_COLOR_ALPHA",
    "headerColumnFont": "FONT",
    "headerColumnText": "TEXT_COLOR"
  },
  "paramsDefaults": {
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "rd": "0",
    "containerBrw": "1",
    "containerBrd": "color_5",
    "containerBg": "color_1",
    "headerDivider_w": "1",
    "headerBg": "color_17",
    "headerText": "color_5",
    "headerFont": "font_9",
    "columnDivider_w": "1",
    "columnDivider": "color_5",
    "headerDivider": "color_5",
    "row2Bg": "color_10",
    "rowBg": "color_1",
    "rowText": "color_5",
    "rowFont": "font_9",
    "rowDivider_w": "1",
    "rowDivider": "color_5",
    "selection": "color_13",
    "linkColor": "color_6",
    "linkHoverColor": "color_7",
    "paginationColor": "#000000",
    "cellPadding": "0",
    "rowOrCellHoverBg": "color_4",
    "headerColumnBg": "color_1",
    "headerColumnFont": "font_9",
    "headerColumnText": "color_5"
  },
  "css": {
    "%_grid": "height:100%;",
    "% #centerRow,% #borderLayout_eRootPanel > #center": "[shd]  [rd]  -webkit-filter:blur(0);",
    "% .ag-root": "border:[containerBrw] solid [containerBrd];[rd]  overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);",
    "% .ag-body-viewport-wrapper": "-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);",
    "% #borderLayout_eRootPanel": "overflow:visible !important;",
    "% .ag-body-viewport": "background:[containerBg];[rd]  border-top-left-radius:0;border-top-right-radius:0;",
    "% .ag-header": "background:[containerBg];padding-bottom:[headerDivider_w];box-sizing:content-box;position:relative;border:none;",
    "% .ag-header .ag-header-viewport": "overflow:visible;",
    "% .ag-header-cell": "background:[headerBg];color:[headerText];[headerFont]  border-right:[columnDivider_w] solid [columnDivider];",
    "% .ag-header-cell:last-child": "border-right:none;",
    "% .ag-header-cell::after": "content:'';position:absolute;width:inherit;left:0;bottom:calc(-1 * [headerDivider_w]);border-bottom:[headerDivider_w] solid [headerDivider];",
    "% .ag-scrolls .ag-body": "background:transparent;top:inherit !important;",
    "% .ag-scrolls .ag-body .ag-row-odd": "background:[row2Bg];",
    "% .ag-scrolls .ag-body .ag-row-even": "background:[rowBg];",
    "% .ag-scrolls .ag-body .ag-row": "color:[rowText];[rowFont]    box-sizing:border-box;border-bottom:[rowDivider_w] solid [rowDivider];",
    "% .ag-scrolls .ag-body .ag-row.ag-row-selected": "background:[selection];",
    "% .ag-scrolls .ag-body img": "max-height:100%;max-width:100%;",
    "% .ag-scrolls .ag-body .ag-body-container": "display:block;",
    "% .ag-overlay-loading-wrapper": "background:rgba(255, 255, 255, 0.3);",
    "% .ag-overlay-loading-center": "background:[containerBg];color:[rowText];[rowFont]  border:none;",
    "% .ag-body .ag-cell": "display:block;height:100%;width:100%;padding:0;",
    "% .ag-body .ag-cell.ag-cell-focus": "background:[selection];border-right:[columnDivider_w] solid [columnDivider];border-left:0;border-top:0;border-bottom:0;",
    "% .ag-body .ag-cell-link": "display:block;height:100%;",
    "% .ag-body .ag-cell-link-inline": "display:inline-block;",
    "% .ag-body .ag-cell-link,% .ag-body .ag-cell-link-inline": "color:[linkColor];",
    "% .ag-body .ag-cell-link:hover,% .ag-body .ag-cell-link-inline:hover": "color:[linkHoverColor];",
    "% .ag-header-cell-label": "position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);white-space:normal;",
    "% .cell-content-wrapper": "position:relative;height:100%;padding:2px;",
    "% .cell-content-wrapper .cell-text-wrapper": "display:table;width:100%;height:100%;",
    "% .cell-content-wrapper .cell-text-wrapper .ag-cell-text": "display:table-cell;vertical-align:middle;white-space:normal;",
    "% .cell-center-vertically": "position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);white-space:normal;",
    "% .ag-cell-no-focus": "border-right:[columnDivider_w] solid [columnDivider];border-left:0;border-top:0;border-bottom:0;",
    "% .ag-cell-no-focus:last-child": "border-right:none;",
    "% .ag-cell-image": "display:block;position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);",
    "% .ag-paging-page-summary-panel": "display:block;text-align:right;color:[paginationColor];[rowFont]",
    "% #pageRowSummaryPanel,% #btFirst,% #btLast": "display:none;",
    "% #btPrevious,% #btNext": "position:relative;width:20px;height:26px;line-height:27px;border:none;background:url('data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20fill%3D%22[paginationColor]%22%20points%3D%2212.8%2C20%2012%2C19.4%2017.7%2C13%2012%2C6.6%2012.8%2C6%2019%2C13%22%2F%3E%3C%2Fsvg%3E');background-size:20px 26px;background-repeat:no-repeat;background-position:center;color:transparent;padding:0;margin:0;",
    "% #btPrevious:not(:disabled),% #btNext:not(:disabled)": "cursor:pointer;",
    "% .ag-paging-panel": "padding:12px 0 0;",
    "% #btPrevious": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "% .ag-paging-button:hover": "opacity:.7;",
    "% .ag-paging-button:disabled": "opacity:.3;",
    "%.hide-pagination-panel .ag-paging-panel": "display:none;",
    "%.align-text-left .ag-header-cell": "text-align:left;padding-left:[cellPadding];",
    "%.align-text-left .ag-row": "text-align:left;",
    "%.align-text-left .ag-row .cell-content-wrapper": "padding-left:[cellPadding];",
    "%.align-text-left .ag-cell-image": "margin-right:auto;",
    "%.align-text-right .ag-header-cell": "text-align:right;padding-right:[cellPadding];",
    "%.align-text-right .ag-row": "text-align:right;",
    "%.align-text-right .ag-row .cell-content-wrapper": "padding-right:[cellPadding];",
    "%.align-text-right .ag-cell-image": "margin-left:auto;",
    "%.align-text-center .ag-header-cell": "text-align:center;padding:0;",
    "%.align-text-center .ag-row": "text-align:center;",
    "%.align-text-center .ag-row .ag-cell": "padding:0;",
    "%.align-text-center .ag-cell-image": "margin:auto;",
    "% .ag-cell-richtext": "height:inherit;",
    "%.disable-horizontal-scroll .ag-body-viewport": "overflow-x:hidden;",
    "% .ag-paging-row-summary-panel": "position:absolute;width:auto;padding-right:2px;",
    "%.select-rows .ag-row:hover": "background:[rowOrCellHoverBg];",
    "%.select-cells .ag-cell:hover": "background:[rowOrCellHoverBg];",
    "%.hide-header .ag-header": "display:none;",
    "% .last-column": "background:[headerColumnBg];[headerColumnFont]  color:[headerColumnText];"
  }
}
 skins['wysiwyg.viewer.skins.GridSkin'] = {
  "react": [
    [
      "div",
      null,
      [
        "_grid"
      ],
      {
        "ref": "grid"
      }
    ]
  ],
  "params": {
    "shd": "BOX_SHADOW",
    "rd": "BORDER_RADIUS",
    "containerBrw": "BORDER_SIZE",
    "containerBrd": "BORDER_COLOR_ALPHA",
    "containerBg": "BG_COLOR_ALPHA",
    "headerDivider_w": "BORDER_SIZE",
    "headerBg": "BG_COLOR_ALPHA",
    "headerText": "TEXT_COLOR",
    "headerFont": "FONT",
    "columnDivider_w": "BORDER_SIZE",
    "columnDivider": "BORDER_COLOR_ALPHA",
    "headerDivider": "BORDER_COLOR_ALPHA",
    "row2Bg": "BG_COLOR_ALPHA",
    "rowBg": "BG_COLOR_ALPHA",
    "rowText": "TEXT_COLOR",
    "rowFont": "FONT",
    "rowDivider_w": "BORDER_SIZE",
    "rowDivider": "BORDER_COLOR_ALPHA",
    "selection": "BG_COLOR_ALPHA",
    "linkColor": "TEXT_COLOR",
    "linkHoverColor": "TEXT_COLOR",
    "paginationColor": "BG_COLOR_ALPHA",
    "cellPadding": "PADDING_RIGHT_SIZE",
    "rowOrCellHoverBg": "BG_COLOR_ALPHA"
  },
  "paramsDefaults": {
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "rd": "0",
    "containerBrw": "1",
    "containerBrd": "color_5",
    "containerBg": "color_1",
    "headerDivider_w": "1",
    "headerBg": "color_17",
    "headerText": "color_5",
    "headerFont": "font_9",
    "columnDivider_w": "1",
    "columnDivider": "color_5",
    "headerDivider": "color_5",
    "row2Bg": "color_10",
    "rowBg": "color_1",
    "rowText": "color_5",
    "rowFont": "font_9",
    "rowDivider_w": "1",
    "rowDivider": "color_5",
    "selection": "color_13",
    "linkColor": "color_6",
    "linkHoverColor": "color_7",
    "paginationColor": "#000000",
    "cellPadding": "0",
    "rowOrCellHoverBg": "color_4"
  },
  "css": {
    "%_grid": "height:100%;",
    "% #centerRow,% #borderLayout_eRootPanel > #center": "[shd]  [rd]  -webkit-filter:blur(0);",
    "% .ag-root": "border:[containerBrw] solid [containerBrd];[rd]  overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);",
    "% .ag-body-viewport-wrapper": "-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);",
    "% #borderLayout_eRootPanel": "overflow:visible !important;",
    "% .ag-body-viewport": "background:[containerBg];[rd]  border-top-left-radius:0;border-top-right-radius:0;",
    "% .ag-header": "background:[containerBg];padding-bottom:[headerDivider_w];box-sizing:content-box;position:relative;border:none;",
    "% .ag-header .ag-header-viewport": "overflow:visible;",
    "% .ag-header-cell": "background:[headerBg];color:[headerText];[headerFont]  border-right:[columnDivider_w] solid [columnDivider];",
    "% .ag-header-cell:last-child": "border-right:none;",
    "% .ag-header-cell::after": "content:'';position:absolute;width:inherit;left:0;bottom:calc(-1 * [headerDivider_w]);border-bottom:[headerDivider_w] solid [headerDivider];",
    "% .ag-scrolls .ag-body": "background:transparent;top:inherit !important;",
    "% .ag-scrolls .ag-body .ag-row-odd": "background:[row2Bg];",
    "% .ag-scrolls .ag-body .ag-row-even": "background:[rowBg];",
    "% .ag-scrolls .ag-body .ag-row": "color:[rowText];[rowFont]    box-sizing:border-box;border-bottom:[rowDivider_w] solid [rowDivider];",
    "% .ag-scrolls .ag-body .ag-row.ag-row-selected": "background:[selection];",
    "% .ag-scrolls .ag-body img": "max-height:100%;max-width:100%;",
    "% .ag-scrolls .ag-body .ag-body-container": "display:block;",
    "% .ag-overlay-loading-wrapper": "background:rgba(255, 255, 255, 0.3);",
    "% .ag-overlay-loading-center": "background:[containerBg];color:[rowText];[rowFont]  border:none;",
    "% .ag-body .ag-cell": "display:block;height:100%;width:100%;padding:0;",
    "% .ag-body .ag-cell.ag-cell-focus": "background:[selection];border-right:[columnDivider_w] solid [columnDivider];border-left:0;border-top:0;border-bottom:0;",
    "% .ag-body .ag-cell-link": "display:block;height:100%;",
    "% .ag-body .ag-cell-link-inline": "display:inline-block;",
    "% .ag-body .ag-cell-link,% .ag-body .ag-cell-link-inline": "color:[linkColor];",
    "% .ag-body .ag-cell-link:hover,% .ag-body .ag-cell-link-inline:hover": "color:[linkHoverColor];",
    "% .ag-header-cell-label": "position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);white-space:normal;",
    "% .cell-content-wrapper": "position:relative;height:100%;padding:2px;",
    "% .cell-content-wrapper .cell-text-wrapper": "display:table;width:100%;height:100%;",
    "% .cell-content-wrapper .cell-text-wrapper .ag-cell-text": "display:table-cell;vertical-align:middle;white-space:normal;",
    "% .cell-center-vertically": "position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);white-space:normal;",
    "% .ag-cell-no-focus": "border-right:[columnDivider_w] solid [columnDivider];border-left:0;border-top:0;border-bottom:0;",
    "% .ag-cell-no-focus:last-child": "border-right:none;",
    "% .ag-cell-image": "display:block;position:relative;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);",
    "% .ag-paging-page-summary-panel": "display:block;text-align:right;color:[paginationColor];[rowFont]",
    "% #pageRowSummaryPanel,% #btFirst,% #btLast": "display:none;",
    "% #btPrevious,% #btNext": "position:relative;width:20px;height:26px;line-height:27px;border:none;background:url('data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpolygon%20fill%3D%22[paginationColor]%22%20points%3D%2212.8%2C20%2012%2C19.4%2017.7%2C13%2012%2C6.6%2012.8%2C6%2019%2C13%22%2F%3E%3C%2Fsvg%3E');background-size:20px 26px;background-repeat:no-repeat;background-position:center;color:transparent;padding:0;margin:0;",
    "% #btPrevious:not(:disabled),% #btNext:not(:disabled)": "cursor:pointer;",
    "% .ag-paging-panel": "padding:12px 0 0;",
    "% #btPrevious": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "% .ag-paging-button:hover": "opacity:.7;",
    "% .ag-paging-button:disabled": "opacity:.3;",
    "%.hide-pagination-panel .ag-paging-panel": "display:none;",
    "%.align-text-left .ag-header-cell": "text-align:left;padding-left:[cellPadding];",
    "%.align-text-left .ag-row": "text-align:left;",
    "%.align-text-left .ag-row .cell-content-wrapper": "padding-left:[cellPadding];",
    "%.align-text-left .ag-cell-image": "margin-right:auto;",
    "%.align-text-right .ag-header-cell": "text-align:right;padding-right:[cellPadding];",
    "%.align-text-right .ag-row": "text-align:right;",
    "%.align-text-right .ag-row .cell-content-wrapper": "padding-right:[cellPadding];",
    "%.align-text-right .ag-cell-image": "margin-left:auto;",
    "%.align-text-center .ag-header-cell": "text-align:center;padding:0;",
    "%.align-text-center .ag-row": "text-align:center;",
    "%.align-text-center .ag-row .ag-cell": "padding:0;",
    "%.align-text-center .ag-cell-image": "margin:auto;",
    "% .ag-cell-richtext": "height:inherit;",
    "%.disable-horizontal-scroll .ag-body-viewport": "overflow-x:hidden;",
    "% .ag-paging-row-summary-panel": "position:absolute;width:auto;padding-right:2px;",
    "%.select-rows .ag-row:hover": "background:[rowOrCellHoverBg];",
    "%.select-cells .ag-cell:hover": "background:[rowOrCellHoverBg];",
    "%.hide-header .ag-header": "display:none;"
  }
}

        return skins;
    }));